import { create } from 'zustand';
import { persist, createJSONStorage, devtools } from 'zustand/middleware';

const defaultUIState = {
  // Mobile sidebar open/closed state
  sidebarOpen: false,
  // Desktop sidebar collapsed state (icon-only mode)
  sidebarCollapsed: false,
};

export const useUIStore = create(
  devtools(
    persist(
      (set) => ({
        ...defaultUIState,

        toggleSidebar: () =>
          set((state) => ({ sidebarOpen: !state.sidebarOpen })),

        setSidebarOpen: (open) =>
          set({ sidebarOpen: open }),

        toggleSidebarCollapsed: () =>
          set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),

        setSidebarCollapsed: (collapsed) =>
          set({ sidebarCollapsed: collapsed }),

        resetUIState: () => set(defaultUIState),
      }),
      {
        name: 'ui-storage',
        storage: createJSONStorage(() => localStorage),
        partialize: (state) => ({ sidebarCollapsed: state.sidebarCollapsed }),
      }
    ),
    { name: 'UI Store' }
  )
);
